import {MapEnum} from "./MapEnum";
import {BaseMapEnum} from "./BaseMapEnum";
import {IMapEnumElement} from "./interface";

export class MapEnumElement extends BaseMapEnum implements IMapEnumElement{

    protected _id: number ;
    protected _name: string;
    protected _owner: typeof MapEnum;
    protected _fieldName: string;
    protected _parent?: IMapEnumElement;

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get owner(): typeof MapEnum {
        return this._owner;
    }

    set owner(value: typeof MapEnum) {
        this._owner = value;
    }


    get fieldName(): string {
        return this._fieldName;
    }


    set fieldName(value: string) {
        this._fieldName = value;
    }
    get parent():IMapEnumElement|undefined{
        return this._parent;
    }

    set parent(value: IMapEnumElement|undefined) {
        this._parent = value;
    }

    constructor(fieldName:string,id: number, name: string,owner:typeof MapEnum<any>,parent:IMapEnumElement|undefined = undefined) {
        super();
        this._fieldName = fieldName;
        this._id = id;
        this._name = name;
        this._owner = owner;
        this._parent = parent;
    }

    toString():string {
        return this._name ?? "";
    }



}